/** Список разрешений экрана для пакета {@link https://npmjs.com/package/vue-mq|vue-mq}
 * @name MQ_BREAKPOINTS
 */
export const MQ_BREAKPOINTS = {
    mobile: 993,
    tablet: 1200,
    desktop: Infinity
}
